const DISPOSABLE_DOMAINS = new Set([
  "mailinator.com","tempmail.com","temp-mail.org","10minutemail.com","guerrillamail.com",
  "yopmail.com","trashmail.com","sharklasers.com","getnada.com","dispostable.com","maildrop.cc",
  "throwawaymail.com","fakeinbox.com","mailnesia.com","mohmal.com","fakemail.net","tmail.com",
  "emailondeck.com","mintemail.com","spamgourmet.com","discard.email","tempmailo.com","luxusmail.org",
]);
export function isDisposableEmail(email: string): boolean {
  const at = email.lastIndexOf("@");
  if (at < 0) return false;
  const domain = email.slice(at + 1).trim().toLowerCase();
  return DISPOSABLE_DOMAINS.has(domain);
}
